// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"IQ-z","carouselContainer":"JQ-z"};